export default {"src":"/_next/static/media/bridge.c4ffb4f0.svg","height":12,"width":17,"blurWidth":0,"blurHeight":0};